import request from '@/utils/request'
import {SUCC_CODE} from './config'


export function login(data) {
  return request({
    url: IPConfig.IP + "/kpi-management/user/login.php",
    method: 'post',
    data
  })
}

// 获取基础数据
export function getBaseInfo(){
  return request({
    url: IPConfig.IP + "/kpi-management/info/base_info.php",
    method: 'get',
    // //params: { encodeout: "utf-8" }

  }).then((res)=>{
    // console.log(res);
    if(res.data.errcode === SUCC_CODE){
      return res.data
    }
    throw new Error ("沒有成功获取数据!")
  }).catch( err => {
    if(err){
      console.log(err)
    }
    return alert("网络超时，请刷新页面重试")
  })

}

//获取部门人员数据
export function getPerson(departId) {
  return request({
    url:  IPConfig.IP + "/kpi-management/info/depart_info.php",
    method: 'get',
    params: { depart_id:departId}
  }).then((res)=>{
    // console.log(res);
    if(res.data.errcode === SUCC_CODE){
      return res.data
    }
    throw new Error ("沒有成功获取数据!")
  }).catch( err => {
    if(err){
      console.log(err)
    }
    return alert("网络超时，请刷新页面重试")
  })
}









// WEBPACK FOOTER //
// ./src/api/user.js